/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_PauseInputs */

const en_common_pause = /** @type {(inputs: Common_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause`)
};

const es_common_pause = /** @type {(inputs: Common_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausar`)
};

/**
* | output |
* | --- |
* | "Pause" |
*
* @param {Common_PauseInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_pause = /** @type {((inputs?: Common_PauseInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_PauseInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_pause(inputs)
	return en_common_pause(inputs)
});